module.exports = __webpack_public_path__ + "static/media/fz_slotedit_pt_BR.db6fba3e.png";